import React from "react";
import Skeleton from "../common/Skeleton";

const TestimonialSkeleton = () => {
  return <Skeleton height="18rem" width="100%" />;
};

export default TestimonialSkeleton;
